import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ProjectsItems = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [news, setNews] = useState([]);

  useEffect(() => {
    getProducts(); 
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://cortex-site.runasp.net/api/Leaderservices`,
        { withCredentials: false }
      );
      setNews(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  // Çoklu dil destekli içerik getirme
  const getLocalizedField = (item, fieldBase) => {
    if (!item) return '';
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase] || '';
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase] || '';
    return item[fieldBase] || ''; // Default: az
  };

  // URL'den filtre durumunu al
  const filterFromURL = searchParams.get('filter') || 'Layihələndirmə';
  const [filter, setFilter] = useState(filterFromURL);

  useEffect(() => {
    setFilter(filterFromURL);
  }, [filterFromURL]);

  const filteredItems = news.filter((item) => {
    if (filter === 'all') return true;
    return String(item.type) === filter;
  });

  const handleFilterChange = (value) => {
    setFilter(value);
    setSearchParams({ filter: value });
  };

  const categories = [
    { value: 'Layihələndirmə', label: t('Layihələndirmə') },
    { value: 'Tikinti-Quraşdırma', label: t('Tikinti-Quraşdırma') },
    { value: 'Servis', label: t('Servis') },
  ];

  return (
    <div className="pt-[56px] md:pt-[88px] bg-[#F9F9F9] font-secondFont">
      <div className="max-w-containerSm md:max-w-container mx-auto">
     {/* Kategoriler */}
<div className="flex overflow-x-auto flex-nowrap scrollbar-hide">
  {categories.map(({ value, label }) => (
    <button
      key={value}
      className={`whitespace-nowrap md:px-8 px-6 py-3 md:text-[18px] ${
        filter === value
          ? 'bg-[#2a3d63] text-white'
          : 'border-b-[1px] border-[#2a3d63] text-[#1C1C1C]'
      }`}
      onClick={() => handleFilterChange(value)}
    >
      {label}
    </button>
  ))}
</div>


        {/* Filtrelenmiş Projeler */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-[32px] md:mt-[56px]">
          {filteredItems.map((item) => (
              <div className='bg-white py-6 px-4 rounded-lg border border-[#E5E5E5] hover:border-[#2a3d63] transition-all duration-300'>
               <p className='text-[#1C1C1C] text-[20px] font-medium text-center'>
                 {getLocalizedField(item, 'title')}
               </p>
               <p className='mt-4 text-[#1C1C1C] text-center'>
                 {getLocalizedField(item, 'description').replace(/<[^>]*>/g, '')}
               </p>
             </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsItems;

  